import { render, staticRenderFns } from "./TableCompanyAdmins.vue?vue&type=template&id=0cc23845"
import script from "./TableCompanyAdmins.vue?vue&type=script&lang=js"
export * from "./TableCompanyAdmins.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports